export default "__VITE_ASSET__BKbSJglT__"